export default __webpack_public_path__ + "static/videodisplaythuder-8c1d2bb2c4b371bc57428b155aaba534.png";